<div class="panel-complementario__seccion lista-comisiones" *ngIf="showingInSettlement">
    <alert id="alert-size" style="z-index: 1050;"></alert>
    <table class="table lista-comisiones__table">
        <thead>
            <tr>
                <th>N°</th>
                <th>Tipo</th>
                <th>Glosa</th>
                <th>Tasa %</th>
                <th>Neto</th>
                <th>Exento</th>
            </tr>
        </thead>
        <tbody *ngFor="let comision of listaComisiones; let index = index" app-item-detalle-comision
            [detalleDte]="comision" [detalleNumero]="index + 1" (deleteDetalle)="deleteItemComision(index)">
        </tbody>
    </table>
    <div class="d-flex justify-content-center">
        <button id="boton_agregar_comision" type="button" class="btn btn-warning" (click)="agregarDetalleComision()">
            <i class="flaticon-add-circular-button"></i>
            Agregar
        </button>
    </div>
</div>
